// src/components/chat/InboxHeader.js
/**
 * InboxHeader — Minimal, responsive tabbed header for the Inbox page
 * Clean Messages/Notifications toggle
 */
import React from 'react';
import { MessageCircle, Bell } from 'lucide-react';

const TABS = {
  MESSAGES: 'messages',
  NOTIFICATIONS: 'notifications',
};

export default function InboxHeader({ activeTab, onTabChange, unreadCount = 0, unreadMessages = 0, safeT }) {
  const fallbackT = (key, fb) => (safeT ? safeT(key, fb) : fb);

  return (
    <div className="sticky top-0 z-30 bg-white dark:bg-neutral-900 border-b border-gray-200 dark:border-neutral-800">
      <div className="max-w-5xl mx-auto">
        {/* Title row */}
        <div className="px-4 pt-3 pb-1 sm:pt-4 sm:pb-2">
          <h1 className="text-lg sm:text-xl font-bold text-foreground">
            {fallbackT('inbox:title', 'Inbox')}
          </h1>
        </div>

        {/* Tab bar */}
        <div className="flex">
          <button
            onClick={() => onTabChange(TABS.MESSAGES)}
            className={`flex-1 py-2.5 px-4 text-sm font-medium flex items-center justify-center gap-2 border-b-2 transition-colors ${
              activeTab === TABS.MESSAGES
                ? 'border-green-600 dark:border-green-400 text-green-600 dark:text-green-400'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            <MessageCircle size={17} />
            <span>{fallbackT('inbox:messages', 'Messages')}</span>
            {unreadMessages > 0 && (
              <span className="ml-1 min-w-[20px] px-1.5 py-0.5 rounded-full text-xs font-bold bg-red-500 text-white">
                {unreadMessages > 99 ? '99+' : unreadMessages}
              </span>
            )}
          </button>

          <button
            onClick={() => onTabChange(TABS.NOTIFICATIONS)}
            className={`flex-1 py-2.5 px-4 text-sm font-medium flex items-center justify-center gap-2 border-b-2 transition-colors ${
              activeTab === TABS.NOTIFICATIONS
                ? 'border-green-600 dark:border-green-400 text-green-600 dark:text-green-400'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            <Bell size={17} />
            <span>{fallbackT('inbox:notifications', 'Notifications')}</span>
            {unreadCount > 0 && (
              <span className="ml-1 min-w-[20px] px-1.5 py-0.5 rounded-full text-xs font-bold bg-red-500 text-white">
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
